import { render, staticRenderFns } from "./Complaintservice.vue?vue&type=template&id=e04cc9ec&scoped=true&"
import script from "./Complaintservice.vue?vue&type=script&lang=js&"
export * from "./Complaintservice.vue?vue&type=script&lang=js&"
import style0 from "./Complaintservice.vue?vue&type=style&index=0&id=e04cc9ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04cc9ec",
  null
  
)

export default component.exports